

























































import Vue from 'vue';
import { mapGetters } from 'vuex';

import api from '@/Api';
import { findSameNamedTorrents } from '@/utils';
import { Torrent } from '../../types';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

@Component({
  computed: {
    ...mapGetters(['allTorrents']),
  },
})
export default class ConfirmDeleteDialog extends Vue {
  @Prop(Array)
  readonly value!: Torrent[]

  deleteFiles = false
  deleteSameNamed = false
  moveSameNamed = false
  submitting = false
  torrents: Torrent[] = []
  sameNamedTorrents: Torrent[] = []

  allTorrents!: Torrent[]

  created() {
    this.torrents = this.value;
    this.sameNamedTorrents = findSameNamedTorrents(this.allTorrents, this.torrents);
  }

  get phoneLayout() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  @Emit('input')
  closeDialog() {
    return []
  }

  async submit() {
    if (this.submitting) {
      return;
    }

    this.submitting = true;

    let torrentsToDelete;
    if (this.deleteSameNamed) {
      torrentsToDelete = this.torrents.concat(this.sameNamedTorrents);
    } else {
      torrentsToDelete = this.torrents;
    }
    const hashes = torrentsToDelete.map((t: any) => t.hash);
    await api.deleteTorrents(hashes, this.deleteFiles);

    this.closeDialog();
  }
}
